import { useState } from 'react';
import './Summary.scss';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Badge,
} from 'reactstrap';

function Summary({ performanceHeader, performanceDetails }) {
  const headerData = performanceHeader?.[0];
  const [openPerformance, setOpenPerformance] = useState('1');
  const [openPCM, setOpenPCM] = useState('1');

  const togglePerformance = id => {
    if (openPerformance === id) {
      setOpenPerformance();
    } else {
      setOpenPerformance(id);
    }
  };

  const togglePCM = id => {
    if (openPCM === id) {
      setOpenPCM();
    } else {
      setOpenPCM(id);
    }
  };

  return (
    <div className="summaryBody">
      <div className="summaryHeader">
        <div className="header">
          <div className="title">Overall Summary</div>
          <Badge className="overallRating">
            Overall Rating: {Math.round(headerData?.Overall_Rating_Calibration)}
          </Badge>
        </div>
        <hr
          style={{
            margin: '10px 0',
            borderTop: '1px solid black',
          }}
        />
      </div>
      <Accordion open={openPerformance} toggle={togglePerformance}>
        <AccordionItem style={{ border: 'none' }}>
          <AccordionHeader targetId="1">
            <div className="pf-header">
              <div>Performance</div>
              <Badge className="pf-overallRating">
                Section Rating:{' '}
                {Math.round(headerData?.Overall_Performance_Rating)}
              </Badge>
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="1">
            <div className="performanceTable">
              <div className="tableHeader">
                <div className="colItem">Name</div>
                <div className="colItem">Self Rating</div>
                <div className="colItem">Manager Rating</div>
                <div className="colItem">Weight(60% Total Score)</div>
              </div>
              <div className="tableBody">
                {performanceDetails
                  ?.filter(item => item?.KPI_Type === 'PERFORMANCE')
                  ?.map((detail, index) => (
                    <div className="rowItem" key={index}>
                      <div className="colItem">{detail?.KPI_Name}</div>
                      <div className="colItem">{detail?.Rating_Self}</div>
                      <div className="colItem">{detail?.Rating_Mgr}</div>
                      <div className="colItem">{detail?.Weightage}%</div>
                    </div>
                  ))}
              </div>
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
      <Accordion open={openPCM} toggle={togglePCM}>
        <AccordionItem style={{ border: 'none' }}>
          <AccordionHeader targetId="1">
            <div className="pf-header">
              <div>PCM</div>
              <Badge className="pf-overallRating">
                Section Rating: {Math.round(headerData?.Overall_PCM_Rating)}
              </Badge>
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="1">
            <div className="performanceTable">
              <div className="tableHeader">
                <div className="colItem">Name</div>
                <div className="colItem">Self Rating</div>
                <div className="colItem">Manager Rating</div>
                <div className="colItem">Weight(40% Total Score)</div>
              </div>
              <div className="tableBody">
                {performanceDetails
                  ?.filter(item => item?.KPI_Type === 'PCM')
                  ?.map((detail, index) => (
                    <div className="rowItem" key={index}>
                      <div className="colItem">{detail?.KPI_Name}</div>
                      <div className="colItem">{detail?.Rating_Self}</div>
                      <div className="colItem">{detail?.Rating_Mgr}</div>
                      <div className="colItem">{detail?.Weightage}%</div>
                    </div>
                  ))}
              </div>
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

export default Summary;
